import { store } from '@betacrew/jars-flux';

export const componentKey = "QBD_FILE_IMPORT";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setFormAndTaxYearList: (state, action) => {
            state.formAndTaxYearList = action.payload;
        },
        setPayersList: (state, action) => {
            state.payersList = action.payload;
        },
        setImportData: (state, action) => {
            state.importData = action.payload;
        },
        setFormSettings: (state, action) => {
            state.formSettings = action.payload;
        },
        setIsImportDataGridViewLoaded: (state, action) => {
            state.isImportDataGridViewLoaded = action.payload;
        },
    },
    initialReducerState: {
        loadingState: false,
        formAndTaxYearList: {},
        payersList: [],
        importData: null,
        formSettings: null,
        isImportDataGridViewLoaded: false
    }
});

export const { setLoadingState, setFormAndTaxYearList, setPayersList, setImportData, setFormSettings, setIsImportDataGridViewLoaded } = actions;